"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M16.6556 14.9917L12.4958 10.8319C12.0366 10.3727 12.0366 9.62729 12.4958 9.16805L16.6556 5.00832C17.1148 4.54908 17.1148 3.80366 16.6556 3.34443C16.1963 2.88519 15.4509 2.88519 14.9917 3.34443L10.8319 7.50416C10.3727 7.96339 9.62729 7.96339 9.16805 7.50416L5.00832 3.34443C4.54908 2.88519 3.80366 2.88519 3.34443 3.34443C2.88519 3.80366 2.88519 4.54908 3.34443 5.00832L7.50416 9.16805C7.96339 9.62729 7.96339 10.3727 7.50416 10.8319L3.34443 14.9917C2.88519 15.4509 2.88519 16.1963 3.34443 16.6556C3.80366 17.1148 4.54908 17.1148 5.00832 16.6556L9.16805 12.4958C9.62729 12.0366 10.3727 12.0366 10.8319 12.4958L14.9917 16.6556C15.4509 17.1148 16.1963 17.1148 16.6556 16.6556C17.1148 16.1963 17.1148 15.4509 16.6556 14.9917Z",
    fill: "#727B7F"
  }));
};